<div class="view-bid-container">
  <div class="view-bid-header">
    <button (click)="goBack()" class="btn btn-back">
      ← {{ backText }}
    </button>
    <h1>{{ titleText }} {{ bidId | docNo:'B':bid?.createdAt }}</h1>
    <div class="actions" *ngIf="bid && !bid.isAccepted && !isBroker">
      <button
        class="btn btn-primary"
        (click)="acceptBid()"
        [disabled]="accepting || dealCreated"
      >
        {{ accepting ? acceptingText : (dealCreated ? dealCreatedText : acceptBidText) }}
      </button>
    </div>
    <div class="actions" *ngIf="bid && bid.isAccepted">
      <div class="badge badge-success">{{ bidAcceptedBadgeText }}</div>
    </div>
  </div>

  <div class="view-bid-content">
    <div *ngIf="loading" class="loading">
      {{ loadingText }}
    </div>

    <div *ngIf="error" class="error-message">
      {{ error }}
    </div>

    <div *ngIf="!loading && !error && bid" class="bid-details">
      <!-- Основная информация -->
      <div class="detail-section">
        <h2>{{ mainInfoTitleText }}</h2>
        <div class="detail-grid">
          <div class="detail-item">
            <span class="detail-label">{{ bidNumberText }}:</span>
            <span class="detail-value">{{ bid.id | docNo:'B':bid.createdAt }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{ priceText }}:</span>
            <span class="detail-value">{{ bid.price | number:'1.2-2' }} {{ bid.currencyCode }}</span>
          </div>
          <div class="detail-item" *ngIf="bid.priceKzt != null && bid.currencyCode !== 'KZT'">
            <span class="detail-label">{{ priceInTengeLabelText }}</span>
            <span class="detail-value">≈ {{ bid.priceKzt | number:'1.2-2' }} ₸</span>
          </div>
          <div class="detail-item" *ngIf="bid.bestPrice">
            <span class="detail-label">{{ ratingLabelText }}</span>
            <span class="detail-value best-price-label">{{ bestPriceLabelText }}</span>
          </div>
          <div class="detail-item" *ngIf="!bid.bestPrice && bid.pricePosition">
            <span class="detail-label">{{ ratingLabelText }}</span>
            <span class="detail-value">{{ bid.pricePosition }}{{ pricePositionSuffixText }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{ deliveryDaysText }}:</span>
            <span class="detail-value">{{ bid.deliveryDays }} {{ daysText }}</span>
          </div>
          <div class="detail-item" *ngIf="bid.createdAt">
            <span class="detail-label">{{ createdAtText }}:</span>
            <span class="detail-value">{{ formatDate(bid.createdAt) }}</span>
          </div>
          <div class="detail-item" *ngIf="bid.updatedAt">
            <span class="detail-label">{{ updatedAtText }}:</span>
            <span class="detail-value">{{ formatDate(bid.updatedAt) }}</span>
          </div>
        </div>
      </div>

      <!-- Услуги -->
      <div class="detail-section">
        <h2>{{ servicesText }}</h2>
        <div class="services-list" *ngIf="bid.services && bid.services.length > 0">
          <div *ngFor="let service of bid.services" class="service-item">
            <span class="service-name">{{ getServiceName(service) }}</span>
          </div>
        </div>
        <div *ngIf="!bid.services || bid.services.length === 0" class="no-services">
          {{ noServicesText }}
        </div>
      </div>

      <!-- Примечание -->
      <div class="detail-section" *ngIf="bid.note">
        <h2>{{ noteText }}</h2>
        <div class="note-content">
          {{ bid.note }}
        </div>
      </div>

      <div class="detail-section" *ngIf="!bid.note">
        <h2>{{ noteText }}</h2>
        <div class="note-content empty">
          {{ noNoteText }}
        </div>
      </div>

      <div *ngIf="acceptError" class="error-message">
        {{ acceptError }}
      </div>
    </div>
  </div>

  <!-- Модальное окно с предупреждением о реквизитах -->
  <div class="modal-overlay" *ngIf="showRequisitesWarning" (click)="closeRequisitesWarning()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>{{ requisitesRequiredTitleText }}</h2>
      </div>
      <div class="modal-body">
        <p>{{ requisitesWarningText }}</p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="closeRequisitesWarning()">
          {{ cancelText }}
        </button>
        <button class="btn btn-primary" (click)="goToProfile()">
          {{ goToProfileText }}
        </button>
      </div>
    </div>
  </div>
</div>
